'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var notification = require('./notification-e5c5bb70.js');

var ErrorNotification = function (props) { return (React__default.createElement(notification.Notification, tslib_es6.__assign({ iconName: "exclamation-triangle", dataTestId: "error-notification", dataCy: "error-notification" }, props))); };

exports.ErrorNotification = ErrorNotification;
